import {SessionType, TldrawCommand, TldrawPatch, WhiteboardStore} from '@modules/whiteboard'

export abstract class BaseSession {
  abstract type: SessionType

  get status() { return this.app.appState.status}
  set status(v) { this.app.appState.status = v}

  constructor(public app: WhiteboardStore) {}

  abstract start: () => TldrawPatch | undefined

  abstract update: () => TldrawPatch | undefined

  abstract complete: () => TldrawPatch | TldrawCommand | undefined

  abstract cancel: () => TldrawPatch | undefined
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/sessions/BaseSession.ts